import type { VariableNode } from './VariablesEntity';

// Transitional — must never surface a user-facing indicator.
const SUPPRESSED_CODES: ReadonlySet<string> = new Set(['ARRAY_GROUPED_MISSING']);

export function getAllEncounteredValidationCodes(node: VariableNode): string[] {
  return (node.validationErrors ?? []).map((error) => error.code);
}

export function getRenderedValidationCodes(node: VariableNode): string[] {
  return getAllEncounteredValidationCodes(node).filter((code) => !SUPPRESSED_CODES.has(code));
}

export function hasFailedValidation(node: VariableNode): boolean {
  return getRenderedValidationCodes(node).length > 0;
}
